const API_URL = process.env.VUE_APP_API_URL;
const VCLOUD_URL = process.env.VUE_APP_VCLOUD_URL;

const DISPLAY_EDIT = (process.env.VUE_APP_DISPLAY_EDIT === '1');
const OTRS_IS_ACTIVE = (process.env.VUE_APP_OTRS_IS_ACTIVE === '1');

export {
  API_URL,
  VCLOUD_URL,
  DISPLAY_EDIT,
  OTRS_IS_ACTIVE,
};
